import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REDUCED_FRICTION_PROMOTED_TO_PPMU_EXPERIMENT = defineFcm(
	'reduced_friction_promoted_to_ppmu_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
